<div class="dashboard-contract-container">
    <div class="dashboard-top-grid">
        <div class="contract-section dashboard-section ccc"
            [ngClass]="{'loading-dashboard-section': !chartHasData.CONTRACTS}">
                <ng-container *ngIf="chartDataLoaded.CONTRACTS; else contractsChartLoading">
                    <div *ngIf="chartHasData.CONTRACTS; else contractsChartNotAvailable"
                        class="contract-container-box">
                        <div class="d-flex gap-3 justify-content-between">
                            <div class="contract-title-box">
                                {{'dashboard.contractView.contract.title' | translate}}
                            </div>
                            <div class="chart-nav d-flex d-md-none align-items-center gap-3">
                                <button type="button"
                                    class="btn arrow-btn"
                                    (click)="previousHandler()"
                                    [disabled]="contract?.isFirst">
                                    <i class="app-icon icon icon-chevron-left icon-xxl"></i>
                                </button>
                                <button type="button"
                                    class="btn arrow-btn"
                                    (click)="nextHandler()"
                                    [disabled]="contract?.isLast">
                                    <i class="app-icon icon icon-chevron-right icon-xxl"></i>
                                </button>
                            </div>
                        </div>

                        <div class="contract-graph-box d-md-flex align-items-center">
                            <button type="button"
                                class="d-none d-md-inline-flex btn arrow-btn"
                                (click)="previousHandler()"
                                [disabled]="contract?.isFirst">
                                <i class="app-icon icon icon-chevron-left icon-xxxl"></i>
                            </button>
                            <div class="contract-wrap-box flex-grow-1">
                                <div class="contract-chart-box" *ngIf="contract && chartOptions">
                                    <apx-chart
                                        HJSuppress #chartContract [series]="chartOptions.series" [chart]="chartOptions.chart" [plotOptions]="chartOptions.plotOptions"
                                        [fill]="chartOptions.fill" [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
                                        [labels]="chartOptions.labels" [states]="chartOptions.states" [responsive]="chartOptions.responsive"
                                    >
                                    </apx-chart>

                                    <div class="contract-chart-legend-box gap-2">
                                        <div class="contract-chart-legend-txt d-flex gap-2">
                                            <div class="chart-legend-dot contract-chart-legend-paid-box"></div>
                                            <div class="chart-legend-txt">
                                                {{contract?.dictionaryContractType.code === ContractType.OPERATIONAL_LEASING ?
                                                ('dashboard.contractView.contract.installmentsPaid' | translate):
                                                ('dashboard.contractView.contract.paidAmount' | translate)}}
                                            </div>
                                        </div>
                                        <div class="contract-chart-legend-txt d-flex gap-2">
                                            <div class="chart-legend-dot contract-chart-legend-outstanding-box"></div>
                                            <div class="chart-legend-txt">
                                                @switch (contract.dictionaryContractType.code) {
                                                    @case (ContractType.OPERATIONAL_LEASING) {
                                                        {{'dashboard.contractView.contract.totalInstallments' | translate}}
                                                    }
                                                    @case (ContractType.FINANCIAL_LEASING) {
                                                        {{('outstandingAmount.financialLeasing' | translate)}}
                                                    }
                                                    @case (ContractType.CREDIT) {
                                                        {{('outstandingAmount.credit' | translate)}}
                                                    }
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="contract-detail-box d-flex flex-column">
                                    <div class="contract-detail-title-box">
                                        <div HJSuppress class="contract-detail-title-txt" (click)="contractNavigateHandler()">
                                            {{contract?.number}}
                                        </div>
                                        <div class="contract-detail-subtitle-txt">
                                            <div HJSuppress class="contract-text-highlight fw-semibold fs-4">
                                                @switch (contract?.dictionaryContractType.code) {
                                                    @case (ContractType.OPERATIONAL_LEASING) {
                                                        {{'contracts.contractType.operationalLeasing' | translate}}
                                                    }
                                                    @case (ContractType.FINANCIAL_LEASING) {
                                                        {{'contracts.contractType.financialLeasing' | translate}}
                                                    }
                                                    @case (ContractType.CREDIT) {
                                                        {{'contracts.contractType.credit' | translate}}
                                                    }
                                                }
                                            </div>
                                            <div *ngIf="(contract?.dictionaryContractType.code === ContractType.FINANCIAL_LEASING || contract?.dictionaryContractType.code === ContractType.CREDIT) && contract?.totalLease"
                                                class="text-secondary">
                                                <span HJSuppress class="fw-bold me-2">
                                                    {{contract?.totalLease | number : '1.'}} {{contract?.currency}}
                                                </span>
                                                <span>
                                                    @switch (contract?.dictionaryContractType.code) {
                                                        @case (ContractType.CREDIT) {
                                                            {{ 'dashboard.contractView.contract.totalCredit' | translate }}
                                                        }
                                                        @default {
                                                            {{ 'dashboard.contractView.contract.totalLease' | translate }}
                                                        }
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="contract-detail-month-box">
                                        <div>
                                            <span HJSuppress class="contract-text-highlight fw-bold">{{contract?.installmentsLeftNumber}}</span>
                                            {{'dashboard.contractView.contract.installmentsLeft' | translate}}
                                        </div>
                                        <div>
                                            <span HJSuppress class="contract-text-highlight fw-bold">{{contract?.assets}}</span>
                                            {{'dashboard.contractView.contract.assetsInContract' | translate}}
                                        </div>
                                        <div HJSuppress *ngIf="contract?.dictionaryContractType.code === ContractType.OPERATIONAL_LEASING || contract?.dictionaryContractType.code === ContractType.CREDIT" >
                                            <span class="contract-text-highlight fw-bold">
                                                {{ contract?.nextPayment | number:'1.2-2' }}
                                                {{ contract?.currency }}
                                            </span>
                                            {{'dashboard.contractView.contract.nextInstallmentAmount' | translate}}
                                        </div>
                                    </div>

                                    <div role="button" class="contract-detail-invoice-box gap-3 py-2 px-3"
                                        (click)="invoiceNavigateHandler()"
                                        [ngClass]="{
                                            'contract-text-paid': contract?.isPaid,
                                            'contract-text-not-paid': !contract?.isPaid && !contract?.isOverdue,
                                            'contract-text-overdue': contract?.isOverdue}">
                                        <div class="d-flex align-items-center justify-content-center">
                                            <i *ngIf="contract?.isPaid"
                                                class="app-icon icon icon-check-circle-fill icon-xl2 paid-icon"></i>
                                            <i *ngIf="!contract?.isPaid && !contract?.isOverdue"
                                                class="app-icon icon icon-invoice-1 icon-xl2 not-paid-icon"></i>
                                            <i *ngIf="contract?.isOverdue"
                                                class="app-icon icon icon-warning-triangle-fill icon-xl2 overdue-icon"></i>
                                        </div>
                                        <div class="contract-detail-invoice-txt-box">
                                            <ng-container *ngIf="contract?.isPaid">
                                                {{'dashboard.contractView.contract.paidInvoice' | translate}}
                                            </ng-container>
                                            <ng-container *ngIf="!contract?.isPaid">
                                                <div HJSuppress>
                                                    <ng-container *ngIf="!contract?.isOverdue">
                                                        <span class="fw-bold">{{contract?.unpaidNumber}}</span>
                                                        {{'dashboard.contractView.contract.unpaidInvoice' | translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="contract?.isOverdue">
                                                        <span class="fw-bold">{{contract?.overdueNumber}}</span>
                                                        {{'dashboard.contractView.contract.overdueInvoice' | translate}}
                                                    </ng-container>
                                                </div>
                                                <div HJSuppress class="contract-text-downlight">
                                                    <ng-container *ngIf="!contract?.isOverdue">
                                                        <span class="fw-bold">{{contract?.remainingDays}}</span>
                                                            {{'dashboard.contractView.contract.daysLeft' | translate}}
                                                            - {{'dashboard.contractView.contract.dueDate' | translate}}
                                                            {{contract?.unpaidDueDate | localizedDate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="contract?.isOverdue">
                                                        <span class="fw-bold">{{contract?.overdueDays}}</span>
                                                            {{'dashboard.contractView.contract.overdueDay' | translate}}
                                                            - {{'dashboard.contractView.contract.dueDate' | translate}}
                                                            {{contract?.overdueDueDate | localizedDate}}
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button"
                                class="d-none d-md-inline-flex btn arrow-btn"
                                (click)="nextHandler()"
                                [disabled]="contract?.isLast">
                                <i class="app-icon icon icon-chevron-right icon-xxxl"></i>
                            </button>
                        </div>

                        <div HJSuppress *ngIf="contracts.length > 0" class="text-center fs-5">
                            <span class="text-primary fw-semibold">{{contract.index}}</span>
                            <span class="text-secondary">/{{contracts.length}} {{contracts.length > 1 ?
                                ('dashboard.contractView.contract.contracts' | translate) :
                                ('dashboard.contractView.contract.contract' | translate)}}
                            </span>
                        </div>
                    </div>

                    <ng-template #contractsChartNotAvailable>
                        <span>{{'dashboard.cannotBuildGraph' | translate}}</span>
                    </ng-template>
                </ng-container>

                <ng-template #contractsChartLoading>
                    <span>{{'dashboard.chartDataLoading' | translate}}</span>
                </ng-template>
        </div>

        <div class="invoice-section dashboard-section ccc"
            [ngClass]="{'loading-dashboard-section': !chartHasData.CONTRACTS}">
            <ng-container *ngIf="chartDataLoaded.INVOICES; else invoicesChartLoading">
                <div class="invoice-title-box">
                    {{'dashboard.contractView.invoice.title' | translate}}
                    <div class="invoice-subtitle-txt">
                        {{'dashboard.contractView.invoice.subtitle' | translate}}
                    </div>
                </div>
                <div *ngIf="chartHasData?.INVOICES;else invoicesChartNotAvailable"
                class="invoice-card-box">
                <div class="invoice-detail-box">
                    <div class="invoice-detail-dot-box flex-shrink-0 invoice-bg-unpaid rounded-circle"> </div>
                    <div HJSuppress class="invoice-detail-number-txt">
                        {{invoicesData?.unpaidInvoices}}
                    </div>
                    <div class="invoice-detail-description-box">
                        {{'dashboard.contractView.invoice.unpaidInvoice' | translate}}
                        <div class="invoice-subtitle-txt">
                            <span HJSuppress class="invoice-text-unpaid fw-bold">{{invoicesData?.remainingDays | replaceIfNull}}</span>
                            {{'dashboard.contractView.invoice.remainingDays' | translate}}
                        </div>
                    </div>
                </div>
                <div class="invoice-separator-box"></div>
                <div class="invoice-detail-box">
                    <div class="invoice-detail-dot-box flex-shrink-0 invoice-bg-overdue rounded-circle"> </div>
                    <div HJSuppress class="invoice-detail-number-txt">
                        {{invoicesData?.overdueInvoices}}
                    </div>
                    <div class="invoice-detail-description-box">
                        {{'dashboard.contractView.invoice.overdueInvoice' | translate}}
                        <div class="invoice-subtitle-txt">
                            <span HJSuppress class="invoice-text-overdue fw-bold">{{invoicesData?.maximumOverdueDays | replaceIfNull}}</span>
                            {{'dashboard.contractView.invoice.maximumOverdueDays' | translate}}
                        </div>
                    </div>
                </div>
            <div class="invoice-separator-box"></div>
                <div class="invoice-detail-box">
                    <div class="invoice-detail-dot-box flex-shrink-0 invoice-bg-paid rounded-circle"></div>
                    <div HJSuppress class="invoice-detail-number-txt">
                        {{invoicesData?.paidInvoices}}
                    </div>
                    <div class="invoice-detail-description-box">
                        {{'dashboard.contractView.invoice.paidInvoice' | translate}}
                        <div class="invoice-subtitle-txt">
                            <span HJSuppress class="invoice-text-paid fw-bold">{{invoicesData?.averagePaidDays | replaceIfNull}}</span>
                                {{'dashboard.contractView.invoice.averagePaidDay' | translate}}
                        </div>
                    </div>
                </div>
                </div>
                <ng-template #invoicesChartNotAvailable>
                    <span>{{'dashboard.cannotBuildGraph' | translate}}</span>
                </ng-template>
            </ng-container>
            <ng-template #invoicesChartLoading>
                <span>{{'dashboard.chartDataLoading' | translate}}</span>
            </ng-template>
        </div>
    </div>

    <div class="payment-section dashboard-section ccc"
        [ngClass]="{'loading-dashboard-section': !chartHasData.PAYMENTS}">
        <ng-container *ngIf="chartDataLoaded.PAYMENTS; else paymentsChartLoading">
            <div *ngIf="chartHasData.PAYMENTS; else paymentsChartNotAvailable"
                class="payment-container-box">
                <div class="d-flex gap-3 justify-content-between">
                    <div class="payment-title-box">
                        {{'dashboard.contractView.payment.title' | translate}}
                        <div class="payment-subtitle-txt">
                            {{'dashboard.contractView.payment.subtitle' | translate}}
                        </div>
                    </div>
                    <div class="chart-nav d-flex d-md-none align-items-center gap-3">
                        <button type="button"
                            class="btn arrow-btn"
                            (click)="loadPrevMonths()"
                            [disabled]="!this.isPrevSwitchEnabled">
                            <i class="app-icon icon icon-chevron-left icon-xxl"></i>
                        </button>
                        <button type="button"
                            class="btn arrow-btn"
                            (click)="loadNextMonths()"
                            [disabled]="!this.isNextSwitchEnabled">
                            <i class="app-icon icon icon-chevron-right icon-xxl"></i>
                        </button>
                    </div>
                </div>


                <div *ngIf="graphOptions">
                    <div class="payment-graph-legend-box">
                        <div>
                            {{'dashboard.contractView.payment.amount' | translate}} ({{paymentsData?.currency}})
                        </div>
                        <div class="payment-graph-paid-amount-box">
                            <div class="d-flex align-items-center">
                                <div class="payment-graph-dot-box past-payment-graph-dot-box flex-shrink-0 rounded-circle"></div>
                                {{'dashboard.contractView.payment.paidAmount' | translate}}
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="payment-graph-dot-box future-payment-graph-dot-box flex-shrink-0 rounded-circle"></div>
                                {{'dashboard.contractView.payment.futurePayments' | translate}}
                            </div>
                        </div>
                    </div>

                    <div class="payment-graph-box d-md-flex align-items-center">
                        <button type="button"
                            class="d-none d-md-inline-flex btn arrow-btn"
                            (click)="loadPrevMonths()"
                            [disabled]="!this.isPrevSwitchEnabled">
                            <i class="app-icon icon icon-chevron-left icon-xxxl"></i>
                        </button>
                        <apx-chart class="flex-grow-1"
                            HJSuppress #chartPayments [series]="graphOptions.series" [chart]="graphOptions.chart" [xaxis]="graphOptions.xaxis"
                            [stroke]="graphOptions.stroke" [dataLabels]="graphOptions.dataLabels" [yaxis]="graphOptions.yaxis"
                            [labels]="graphOptions.labels" [legend]="graphOptions.legend" [title]="graphOptions.title"
                            [subtitle]="graphOptions.subtitle" [tooltip]="graphOptions.tooltip" [markers]="graphOptions.markers"
                            [grid]="graphOptions.grid" [annotations]="graphOptions.annotations" [fill]="graphOptions.fill"
                            [responsive]="graphOptions.responsive"
                        >
                        </apx-chart>
                        <button type="button"
                            class="d-none d-md-inline-flex btn arrow-btn"
                            (click)="loadNextMonths()"
                            [disabled]="!this.isNextSwitchEnabled">
                            <i class="app-icon icon icon-chevron-right icon-xxxl"></i>
                        </button>
                    </div>
                </div>
            </div>

            <ng-template #paymentsChartNotAvailable>
                <span>{{'dashboard.cannotBuildGraph' | translate}}</span>
            </ng-template>
        </ng-container>

        <ng-template #paymentsChartLoading>
            <span>{{'dashboard.chartDataLoading' | translate}}</span>
        </ng-template>
    </div>
</div>
